import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import ModalBtn from '../../molecules/modalButton/view';
import ComprobanteForm from '../../molecules/ComprobanteForm/view.jsx';
import { createComprobante } from '../../../usecases/accounting-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';

function CreateComprobante() {
    const handleSave = async (formData) => {
        try {
            await createComprobante(formData);
            dispatchCustomEvent("close-createComprobanteModal-modal", []);
            dispatchCustomEvent("popup", { message: "Comprobante creado correctamente", type: "success" });
            dispatchCustomEvent("reload-comprobantes", {});
        } catch (error) {
            console.error("Error creating comprobante:", error);
            dispatchCustomEvent("popup", { message: "Error creando comprobante", type: "error" });
            dispatchCustomEvent('loading-btn-comprobante-save', {});
        }
    };

    return (
        <ModalBtn
            id="createComprobanteModal"
            className='btn-create-comprobante'
            icon={<AiOutlinePlus />}
            title="Crear Comprobante"
            width="80vw"
            style={{ width: '95vw', height: '95vh' }}
        >
            <ComprobanteForm
                onSave={handleSave}
            />
        </ModalBtn>
    );
}

export default CreateComprobante;
